class DragDropZone {
  constructor ( element ) {
    this.token;
    this.files       = [];
    this.element     = element;
    this.form        = this.element.closest('form');
    this.submitBtn   = this.form.querySelector('button[type="submit"]');
    this.input       = this.element.querySelector('input[type="file"]');
    this.placeholder = this.element.querySelector('.drop-zone__placeholder');
    this.list        = this.element.querySelector('.drop-zone__list');

    this.element.addEventListener('dragover', (e) => this.dragOverHandler(e) );
    this.element.addEventListener('dragleave', (e) => this.element.classList.remove('dragover') );
    this.element.addEventListener('drop', (e) => this.dropHandler(e) );
    this.input.addEventListener('change', (e) => this.changeHandler(e) );
  }

  dragOverHandler(e) {
    e.preventDefault();

    this.element.classList.add('dragover');
  }

  dropHandler(e) {
    e.preventDefault();

    this.element.classList.remove('dragover');

    this.addFiles(Object.values(e.dataTransfer.files));
  }

  changeHandler(e) {
    e.preventDefault();
    
    this.addFiles(Object.values(e.target.files));
  }

  ensureTokenHiddenField() {
    let hidden = this.form.querySelector('input[name="preupload_token"]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'preupload_token';
      this.form.appendChild(hidden);
    }
    return hidden;
  }

  getToken() {
    if (this.token) return this.token;

    // Generate once and persist both in the instance and in a hidden input
    this.token = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
    const hidden = this.ensureTokenHiddenField();
    hidden.value = this.token;

    return this.token;
  }

  addFiles(files) {
    const newFiles = [...files].filter(file => this.validateFile(file));
    if (newFiles.length === 0) return;

    // Ensure we keep a single token and persist it on first use
    const token = this.getToken();

    // Disable submit while new uploads are in-flight
    this.submitBtn.disabled = true;

    for (const file of newFiles) {
      // Append to our internal list first
      this.files.push(file);

      // Render only if not already present (no full re-render)
      if (!this.list.querySelector(`figure[data-index="${file.name}"]`)) {
        this.renderListItem(file);
      }

      // Start the upload after the item exists in DOM
      this.preuploadFileDirect(token, file).catch((err) => {
        // Stop spinner on error
        const fig = this.list.querySelector(`figure[data-index="${file.name}"]`);
        if (fig) fig.classList.remove('ajax_loading');
        console.error('Preupload failed:', err);
        this.updateSubmitAvailability();
      });
    }

    // Sync input files (do not re-render list here)
    this.updateInput();
  }

  updateInput() {
    let data = new DataTransfer();

    this.files.forEach(file => {
      data.items.add(file);
    });

    this.input.files = data.files;
    
    this.updatePlaceholder();
    // Do not re-render the list here to preserve per-item state during uploads
  }

  updateSubmitAvailability() {
    // Enable submit only when no items are marked as loading
    const anyLoading = !!this.list.querySelector('.ajax_loading');
    this.submitBtn.disabled = anyLoading;
  }

  // uploadFile(file) {
  //   // Send file to server
  //   let data = new FormData();
  //   data.append('file', file);
  //   data.append('action', 'upload_to_s3');

  //   fetch( __wpObject.ajaxUrl, {
  //     method: 'POST',
  //     body: data,
  //     headers: {
  //       'X-WP-Nonce': __wpObject.nonce
  //     }
  //   }).then(response => response.json())
  //     .then(response => {
  //       if (response.success) {
  //         console.log(`File "${file.name}" uploaded successfully!`);
  //       } else {
  //         console.error(`Error uploading file "${file.name}": ${response.data.error}`);
  //       }
  //     }).catch(error => {
  //       console.error(`Error uploading file "${file.name}":`, error);
  //     });
  // }

  validateFile(file) {
    // Check if file is empty
    if (file.size === 0) {
      alert(`File "${file.name}" is empty!`);
      return false;
    }

    //Check if total file count exceeds limit
    if (this.files.length >= 5) {
      alert('You can upload only 5 files!');
      return false;
    }

    // Check if file is a duplicate
    if ( this.files.length > 0 && this.files.some(f => f.name === file.name)) {
      alert(`File "${file.name}" is a duplicate!`);
      return false;
    }

    // Check if file has valid extension
    const validExtensions = this.input.accept.split(',').map(ext => ext.trim().toLowerCase());
    const fileExtension   = file.name.split('.').pop().toLowerCase();
    if (!validExtensions.includes(`.${fileExtension}`)) {
      alert(`File "${file.name}" has an invalid extension! Allowed extensions: ${validExtensions.join(', ')}`);
      return false;
    }

    // Check if file size is valid
    if (file.size > 10485760) { // 10 MB
      alert(`File "${file.name}" is too big! Max file size is 10MB.`);
      return false;
    }

    return true;
  }

  updatePlaceholder () {
    if ( this.files.length > 0 ) {
      this.placeholder.style.display = 'none';
    } else {
      this.placeholder.style.display = 'flex';
    }
  }

  renderListItem( file, i ) {
    let tmppath = URL.createObjectURL(file);
    let img       = document.createElement('img');
    let figure    = document.createElement('figure');
    let remove    = document.createElement('button');
    let capture   = document.createElement('figcaption');
    let preloader = document.createElement('div');
    let spinner   = document.createElement('span');
    
    img.src = tmppath;
    img.alt = file.name;
    // capture.textContent = file.name;
    remove.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576zM231 231C240.4 221.6 255.6 221.6 264.9 231L319.9 286L374.9 231C384.3 221.6 399.5 221.6 408.8 231C418.1 240.4 418.2 255.6 408.8 264.9L353.8 319.9L408.8 374.9C418.2 384.3 418.2 399.5 408.8 408.8C399.4 418.1 384.2 418.2 374.9 408.8L319.9 353.8L264.9 408.8C255.5 418.2 240.3 418.2 231 408.8C221.7 399.4 221.6 384.2 231 374.9L286 319.9L231 264.9C221.6 255.5 221.6 240.3 231 231z"/></svg>';
    remove.classList.add('drop-zone__remove');
    spinner.classList.add('spinner');
    preloader.classList.add('drop-zone__preloader');
    figure.classList.add('ajax_loading');

    figure.setAttribute('data-index', file.name);

    remove.addEventListener( 'click', (e) => this.removeFile(e) );
    
    figure.appendChild(img);
    figure.appendChild(capture);
    figure.appendChild(remove);
    figure.appendChild(preloader);
    preloader.appendChild(spinner);

    this.list.appendChild(figure);
  }

  removeFile( e ) {
    e.preventDefault();

    let nodes = this.list.children;
    let parent = e.target.closest('figure');
    let index = Array.prototype.indexOf.call(nodes, parent);
    
    this.files.splice(index, 1);

    // Remove the corresponding figure from DOM
    if (parent && parent.parentNode) parent.parentNode.removeChild(parent);

    this.updateInput();
    this.updateSubmitAvailability();
  }

  renderList() {
    this.list.innerHTML = '';

    [...this.input.files].forEach( (file, i) => {
      this.renderListItem( file, i );
    } );
  }

  reset () {
    this.files = [];
    this.updateInput();
  }

  async presignPost(token, file) {
    const body = new FormData();
    body.append('action', 'taa_s3_presign_post');
    body.append('token', token);
    body.append('filename', file.name);
    body.append('mime', file.type || 'application/octet-stream');
    const res = await fetch(_wpObject.ajaxUrl, { method: 'POST', body });
    const json = await res.json();
    if (!json.success) throw new Error(json.data?.error || 'presign failed');
    return json.data; // { url, fields, key, token }
  }

  async uploadViaPostToS3({ url, fields }, file, onProgress) {
    console.log('S3 POST fields:', Object.keys(fields));
    
    return await new Promise((resolve, reject) => {
      const fd = new FormData();
      Object.entries(fields).forEach(([k, v]) => fd.append(k, v));
      fd.append('file', file); // файл ОБЯЗАТЕЛЬНО последним

      const xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.upload.onprogress = (e) => {
        if (onProgress && e.lengthComputable) onProgress(e.loaded / e.total);
      };
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 201) {
            resolve(xhr.responseText);
          } else {
            console.error('S3 POST response:', xhr.responseText); // тут будет <Error><Code>...</Code>...
            reject(new Error(`S3 POST failed: ${xhr.status}`));
          }
        }
      };
      xhr.onerror = () => reject(new Error('Network error'));
      xhr.send(fd);
    });
  }

  async preuploadFileDirect(token, file) {
    const signed = await this.presignPost(token, file);

    await this.uploadViaPostToS3(signed, file, (p) => {
      let progress   = (p * 100).toFixed(0);
      let figure     = this.list.querySelector(`figure[data-index="${file.name}"]`);
      let figcaption = figure.querySelector('figcaption');

      figcaption.textContent = `Loading (${progress}%)`;

      if (progress >= 100) {
        figure.classList.remove('ajax_loading');
        figcaption.textContent = file.name;
        this.updateSubmitAvailability();
        //TODO: add data attribute with S3 URL for later use (remove)
      }
    });

    return { key: signed.key, token: signed.token };
  }
}

export default DragDropZone;
